import { render, staticRenderFns } from "./SetLabelDialog.vue?vue&type=template&id=80bda3f8&scoped=true"
import script from "./SetLabelDialog.vue?vue&type=script&lang=js"
export * from "./SetLabelDialog.vue?vue&type=script&lang=js"
import style0 from "./SetLabelDialog.vue?vue&type=style&index=0&id=80bda3f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80bda3f8",
  null
  
)

export default component.exports